// extracted by mini-css-extract-plugin
module.exports = {"container":"FAQSection_container__oE1yI","heading":"FAQSection_heading__Rt1rA"};